import { colorsCromatic } from "../../../../../themes/colors";

export function getColorsArray(quantity, colorMode, offset = 0) {
  let colorsDefault = colorsCromatic(colorMode);

  return returnColors(
    [...Object.values(colorsDefault["chartMaps"])],
    quantity,
    offset,
  );
}

const returnColors = (colorShades, num, offset) => {
  return Array.from(
    { length: num },
    (_, i) => colorShades[(i + offset) % colorShades.length],
  );
};
